import { render, staticRenderFns } from "./ModalRemoveMedia.vue?vue&type=template&id=30ea7512"
import script from "./ModalRemoveMedia.vue?vue&type=script&lang=js"
export * from "./ModalRemoveMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports